import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { Card } from '@/components/new-ui/card';
import { cn } from '@/lib/utils';

type MediaEmptyStateProps = {
  icon: ReactNode;
  // optional secondary line
  description?: string;
  // call to action, only passed for users who can write
  action?: ReactNode;
  className?: string;
};

// Empty state of the media section pages, dashed card with an icon tile
export const MediaEmptyState = ({ icon, description, action, className }: MediaEmptyStateProps) => {
  const { t } = useTranslation();

  return (
    <Card className={cn('new-ui border-dashed', className)}>
      <div className="flex flex-col items-center justify-center gap-4 px-4 py-16 text-center">
        <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-gradient-to-br from-primary/20 to-primary/5 text-primary [&_svg]:h-8 [&_svg]:w-8">
          {icon}
        </div>
        <div className="space-y-1">
          <p className="text-lg font-semibold text-foreground">{t('noContent')}</p>
          {description ? (
            <p className="max-w-sm text-sm text-muted-foreground">{description}</p>
          ) : null}
        </div>
        {action}
      </div>
    </Card>
  );
};
